import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('fizz_factory', {
  cherry: 'soda_bottle',
  lemon: 'candy_cog',
  orange: 'pressure_valve',
  bell: 'lime_vat',
  star: 'wonderfizz_machine',
  seven: 'candy_conveyor',
  gem: 'fizz_crystal',
  scatter: 'big_red_button',
  money: 'fizz_vault',
});

/** Fizz Factory — GENERATED by scaffoldSlot from
 *  content/slots/fizz_factory.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const FIZZ_FACTORY_THEME: Theme = {
  id: 'fizz_factory',
  name: 'Fizz Factory',
  palette: {
    accent: 0x21c0e0,
    secondary: 0x9b4dff,
    warm: 0xe0a52e,
    frameFill: 0x1a1030,
    bgGradientTop: 0x201640,
    bgGradientBottom: 0x0a0618,
    dimOverlay: 0x05080d,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Fizzy Soda', glyph: '🥤', tint: 0x21c0e0, weight: 5, textureAlias: 'fizz_factory:cherry',
        winVideoAlias: 'fizz_factory:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Candy Cog', glyph: '⚙️', tint: 0xe0a52e, weight: 5, textureAlias: 'fizz_factory:lemon',
        winVideoAlias: 'fizz_factory:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Pressure Valve', glyph: '🔩', tint: 0xff7a3c, weight: 4, textureAlias: 'fizz_factory:orange',
        winVideoAlias: 'fizz_factory:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Lime Fizz Vat', glyph: '🧪', tint: 0x7ed957, weight: 3, textureAlias: 'fizz_factory:bell',
        winVideoAlias: 'fizz_factory:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Wonderfizz Machine', glyph: '⭐', tint: 0x9b4dff, weight: 2, textureAlias: 'fizz_factory:star',
        winVideoAlias: 'fizz_factory:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Candy Conveyor', glyph: '🏭', tint: 0x21c0e0, weight: 2, textureAlias: 'fizz_factory:seven',
        winVideoAlias: 'fizz_factory:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Fizz Crystal', glyph: '💎', tint: 0x9b4dff, weight: 2.5, textureAlias: 'fizz_factory:gem',
        winVideoAlias: 'fizz_factory:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Big Red Button', glyph: '🔴', tint: 0xff4d4d, weight: 0.5, textureAlias: 'fizz_factory:scatter',
        winVideoAlias: 'fizz_factory:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Factory Vault', glyph: '🪙', tint: 0xe0a52e, weight: 1, textureAlias: 'fizz_factory:money',
        winVideoAlias: 'fizz_factory:money:win:video', winVideoSpeed: 2, isMoney: true },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x1a1030, multiplier: 0, weight: 3 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0x21c0e0, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xe0a52e, multiplier: 2, weight: 4 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0x9b4dff, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0x21c0e0, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xe0a52e, multiplier: 5, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xe0a52e, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x1a1030, multiplier: 0, weight: 2 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0x9b4dff, multiplier: 3, weight: 3 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0x21c0e0, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xe0a52e, multiplier: 5, weight: 2 },
      { id: 'x15-a', kind: 'multiplier', label: '×15', tint: 0xe0a52e, multiplier: 15, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'fizz_factory:bg', path: 'environment/fizz_factory.png' },
      columnBackground: { alias: 'fizz_factory:column_bg', path: 'reel/fizz_factory_column_bg.png' },
      border: { alias: 'fizz_factory:border', path: 'brand/border_candy.png' },
    },
  },
};
